"use client";

import { LazyMotion } from "framer-motion";

// Dynamically import the animation features to reduce initial bundle size
const loadFeatures = () => import("framer-motion").then((res) => res.domAnimation);

export default function AnimationProvider({ children }) {
  return (
    <LazyMotion features={loadFeatures} strict>
      {children}
    </LazyMotion>
  );
}
